import React from "react";
import "./style.scss";

export const PrivacyPolicy = ({ lang }) => {
  const isRu = lang === "ru";
  return (
    <section>
      <div className="container">
        <h4 className="privacy-header">
          <strong>
            <b>
              {isRu
                ? "Политика конфиденциальности"
                : "Personal Data Processing Policy"}
            </b>
          </strong>
        </h4>

        <h5>
          <strong>
            <b>1. {isRu ? "Общие положения" : "General provisions"}</b>
          </strong>
        </h5>
        {isRu ? (
          <>
            <div className="privacy-list-item">
              <span className="privacy-number">1.1</span>
              <p>
                Настоящая Политика конфиденциальности обработки персональных
                данных составлена в соответствии с требованиями Федерального
                закона от 27.07.2006 №152-ФЗ «О персональных данных» и
                определяет порядок обработки персональных данных и меры по
                обеспечению безопасности персональных данных, предпринимаемые
                Обществом с ограниченной ответственностью "АЙТИФОКС" (далее -
                Оператор) и Утверждена Приказом генерального директора ООО
                "АЙТИФОКС" № 1-ПДН от 09.01.2025 г.;
              </p>
            </div>

            <div className="privacy-list-item">
              <span className="privacy-number">1.2</span>
              <p>
                Информация, собираемая посредством заполнения форм на сайте,
                обрабатывается Обществом с ограниченной ответственностью ООО
                "АЙТИФОКС" (354354, Краснодарский край, г.о. город-курорт Сочи,
                г. Сочи, р-н Адлерский, ул. Лесная, д. 7, кв. 1/А, ОГРН
                1202300067056);
              </p>
            </div>

            <div className="privacy-list-item">
              <span className="privacy-number">1.2</span>
              <p>
                ООО "АЙТИФОКС" ставит своей важнейшей целью и условием
                осуществления своей деятельности соблюдение прав и свобод
                человека и гражданина при обработке его персональных данных, в
                том числе защиты прав на неприкосновенность частной жизни,
                личную и семейную тайну.
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">1.3</span>
              <p>
                Настоящая Политика конфиденциальности ООО "АЙТИФОКС" в отношении
                обработки персональных данных (далее - Политика) применяется ко
                всей информации, которую ООО "АЙТИФОКС" может получить о
                посетителях веб-сайта{" "}
                <a
                  href="https://mobile.itfox-web.com"
                  style={{ color: "#FFa910" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  mobile.itfox-web.com
                </a>
                .
              </p>
            </div>
          </>
        ) : (
          <p></p>
        )}

        <h5>
          <strong>
            <b>
              2.{" "}
              {isRu
                ? "Основные понятия, используемые в Политике"
                : "Basic concepts used in the Policy"}
            </b>
          </strong>
        </h5>
        {isRu ? (
          <>
            <div className="privacy-list-item">
              <span className="privacy-number">2.1</span>
              <p>
                Автоматизированная обработка персональных данных - обработка
                персональных данных с помощью средств вычислительной техники;
              </p>
            </div>

            <div className="privacy-list-item">
              <span className="privacy-number">2.2</span>
              <p>
                Блокирование персональных данных - временное прекращение
                обработки персональных данных (за исключением случаев, если
                обработка необходима для уточнения персональных данных);
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.3</span>
              <p>
                Веб-сайт - совокупность графических и информационных материалов,
                а также программ для ЭВМ и баз данных, обеспечивающих их
                доступность в сети интернет по сетевому адресу{" "}
                <a
                  href="https://mobile.itfox-web.com"
                  style={{ color: "#FFa910" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  mobile.itfox-web.com
                </a>
                ;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.4</span>
              <p>
                Информационная система персональных данных - совокупность
                содержащихся в базах данных персональных данных, и
                обеспечивающих их обработку информационных технологий и
                технических средств;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.5</span>
              <p>
                Обезличивание персональных данных - действия, в результате
                которых невозможно определить без использования дополнительной
                информации принадлежность персональных данных конкретному
                Пользователю или иному субъекту персональных данных;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.6</span>
              <p>
                Обработка персональных данных - любое действие (операция) или
                совокупность действий (операций), совершаемых с использованием
                средств автоматизации или без использования таких средств с
                персональными данными, включая сбор, запись, систематизацию,
                накопление, хранение, уточнение (обновление, изменение),
                извлечение, использование, передачу (распространение,
                предоставление, доступ), обезличивание, блокирование, удаление,
                уничтожение персональных данных;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.7</span>
              <p>
                Оператор - юридическое лицо, самостоятельно или совместно с
                другими лицами организующие и (или) осуществляющие обработку
                персональных данных, а также определяющие цели обработки
                персональных данных, состав персональных данных, подлежащих
                обработке, действия (операции), совершаемые с персональными
                данными;
              </p>{" "}
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.8</span>
              <p>
                Персональные данные - любая информация, относящаяся прямо или
                косвенно к определенному или определяемому Пользователю
                веб-сайта{" "}
                <a
                  href="https://mobile.itfox-web.com"
                  style={{ color: "#FFa910" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  mobile.itfox-web.com
                </a>
                ;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.9</span>
              <p>
                Пользователь - любой посетитель веб-сайта{" "}
                <a
                  href="https://mobile.itfox-web.com"
                  style={{ color: "#FFa910" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  mobile.itfox-web.com
                </a>
                ;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.10</span>
              <p>
                Предоставление персональных данных - действия, направленные на
                раскрытие персональных данных определенному лицу или
                определенному кругу лиц;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.11</span>
              <p>
                Распространение персональных данных - любые действия,
                направленные на раскрытие персональных данных неопределенному
                кругу лиц (передача персональных данных) или на ознакомление с
                персональными данными неограниченного круга лиц, в том числе
                обнародование персональных данных в средствах массовой
                информации, размещение в информационно-телекоммуникационных
                сетях или предоставление доступа к персональным данным
                каким-либо иным способом;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.12</span>
              <p>
                Трансграничная передача персональных данных - передача
                персональных данных на территорию иностранного государства
                органу власти иностранного государства, иностранному физическому
                или иностранному юридическому лицу;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">2.13</span>
              <p>
                Уничтожение персональных данных - любые действия, в результате
                которых персональные данные уничтожаются безвозвратно с
                невозможностью дальнейшего восстановления содержания
                персональных данных в информационной системе персональных данных
                и (или) уничтожаются материальные носители персональных данных.
              </p>
            </div>
          </>
        ) : (
          <p></p>
        )}

        <h5>
          <strong>
            <b>
              3.{" "}
              {isRu
                ? "Оператор может обрабатывать следующие персональные данные Пользователя"
                : "Personal data processed by the Operator"}
            </b>
          </strong>
        </h5>
        {isRu ? (
          <>
            <div className="privacy-list-item">
              <span className="privacy-number">3.1</span>
              <p>
                Фамилия, имя, отчество, дата рождения, образование, место
                работы, опыт профессиональной деятельности, местоположение,
                IP-адреса, электронный адрес, номера телефонов. Сведения о дате
                рождения, образовании, месте работы и опыте профессиональной
                деятельности обрабатываются исключительно в случае отклика
                Пользователя на вакансии или при рассмотрении кандидатуры на
                трудоустройство;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">3.2</span>
              <p>
                Также на сайте происходит сбор и обработка обезличенных данных о
                посетителях (в т.ч. файлов cookie) с помощью сервисов
                интернет-статистики (Яндекс Метрика и Яндекс Вебмастер и
                других);
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">3.3</span>
              <p>
                Вышеперечисленные данные далее по тексту Политики объединены
                общим понятием Персональные данные.
              </p>
            </div>
          </>
        ) : (
          <p></p>
        )}

        <h5>
          <strong>
            <b>
              4.{" "}
              {isRu
                ? "Цели обработки персональных данных"
                : "Purposes of personal data processing"}
            </b>
          </strong>
        </h5>
        {isRu ? (
          <>
            <p>
              Обработка персональных данных производится в законных целях: для
              взаимодействия с Пользователем, предоставления услуг, исполнения
              законодательных требований или для защиты законных интересов
              Оператора в случаях, предусмотренных правом.
            </p>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                margin: "16px 0",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Цели обработки информации
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Категория персональных данных
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Персональные данные
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Информирование Пользователя посредством отправки электронных
                    писем; заключение, исполнение и прекращение договоров
                    оказания услуг
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Общие
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    ФИО, дата рождения, электронная почта, номер телефона,
                    образование, место работы
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Направление Пользователю уведомлений о новых продуктах и
                    услугах, специальных предложениях и различных событиях.
                    Пользователь всегда может отказаться от получения
                    информационных сообщений, направив Оператору письмо на адрес
                    электронной почты с пометкой «Отказ от уведомлений о новых
                    продуктах и услугах и специальных предложениях»
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Общие
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    ФИО, дата рождения, электронная почта, номер телефона,
                    образование, место работы
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Сбор обезличенных данных Пользователя с помощью сервисов
                    интернет-статистики, служащих для сбора информации о
                    действиях Пользователей на сайте, улучшения качества сайта и
                    его содержания
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Общие
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    IP-адрес устройства Пользователя, местоположение, файлы
                    cookies
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Соблюдение обязательных требований законодательства РФ
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Общие
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    ФИО, дата рождения, электронная почта, номер телефона,
                    IP-адрес устройства Пользователя, местоположение, файлы
                    cookies
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Возможное использование данных Пользователя при
                    трудоустройстве, рассмотрение возможности трудоустройства
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    Общие
                  </td>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                    ФИО, дата рождения, электронная почта, номер телефона,
                    образование, место работы
                  </td>
                </tr>
              </tbody>
            </table>
          </>
        ) : (
          <p></p>
        )}

        <h5>
          <strong>
            <b>
              5.{" "}
              {isRu
                ? "Правовые основания обработки персональных данных"
                : "Legal grounds for processing"}
            </b>
          </strong>
        </h5>
        {isRu ? (
          <>
            <div className="privacy-list-item">
              <span className="privacy-number">5.1</span>
              <p>
                Оператор обрабатывает персональные данные Пользователя только в
                случае их заполнения и/или отправки Пользователем самостоятельно
                через специальные формы, расположенные на сайте{" "}
                <a
                  href="https://mobile.itfox-web.com"
                  style={{ color: "#FFa910" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  mobile.itfox-web.com
                </a>
                . Заполняя соответствующие формы и/или отправляя свои
                персональные данные Оператору, Пользователь выражает свое
                согласие с данной Политикой;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">5.2</span>
              <p>
                Оператор обрабатывает обезличенные данные о Пользователе в
                случае, если это разрешено в настройках браузера Пользователя
                (включено сохранение файлов cookie и использование технологии
                JavaScript).
              </p>
            </div>
          </>
        ) : (
          <p></p>
        )}

        <h5>
          <strong>
            <b>
              6.{" "}
              {isRu
                ? "Порядок сбора, хранения, передачи и других видов обработки персональных данных"
                : "Data processing procedures"}
            </b>
          </strong>
        </h5>
        {isRu ? (
          <>
            <div className="privacy-list-item">
              <span className="privacy-number">6.1</span>
              <p>
                Безопасность персональных данных, которые обрабатываются
                Оператором, обеспечивается путем реализации правовых,
                организационных и технических мер, необходимых для выполнения в
                полном объеме требований действующего законодательства в области
                защиты персональных данных;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">6.2</span>
              <p>
                Оператор обеспечивает сохранность персональных данных и
                принимает все возможные меры, исключающие доступ к персональным
                данным неуполномоченных лиц;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">6.3</span>
              <p>
                Персональные данные могут передаваться третьим лицам,
                привлекаемым Оператором для оказания услуг по аналитике,
                технической поддержке и обеспечению функционирования сайта,
                исключительно в целях его работы и улучшения качества
                предоставляемых услуг. Передача персональных данных также может
                осуществляться в случаях, предусмотренных действующим
                законодательством Российской Федерации;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">6.4</span>
              <p>
                В случае выявления неточностей в персональных данных,
                Пользователь может актуализировать их самостоятельно, путем
                направления Оператору уведомления на адрес электронной почты
                Оператора с пометкой «Актуализация персональных данных»;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">6.5</span>
              <p>
                Срок обработки персональных данных определяется целями обработки
                и действует до их достижения либо до отзыва согласия субъектом
                персональных данных, если иное не предусмотрено
                законодательством РФ;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">6.6</span>
              <p>
                Пользователь имеет право:
                <ul>
                  <li>– получать информацию о своих персональных данных;</li>
                  <li>
                    – требовать их уточнения, блокирования или уничтожения;
                  </li>
                  <li>– отзывать согласие на обработку персональных данных;</li>
                </ul>
                <br />
                направив Оператору уведомление посредством электронной почты на
                электронный адрес Оператора с пометкой «Персональные данные».
              </p>
            </div>
          </>
        ) : (
          <p></p>
        )}

        <h5>
          <strong>
            <b>7. {isRu ? "Заключительные положения" : "Final provisions"}</b>
          </strong>
        </h5>
        {isRu ? (
          <>
            <div className="privacy-list-item">
              <span className="privacy-number">7.1</span>
              <p>
                Для получения разъяснений по любым вопросам, связанным с
                обработкой персональных данных, Пользователь может обратиться к
                Оператору, используя следующие каналы связи:
                <ul>
                  <br />
                  <li>
                    · Электронная почта:{" "}
                    <a
                      href="mailto:hello@itfox-web.com"
                      style={{ color: "#FFa910" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      hello@itfox-web.com
                    </a>
                  </li>
                  <li>
                    {" "}
                    · Почтовый адрес: 354354, Краснодарский край, г.о.
                    город-курорт Сочи, г. Сочи, р-н Адлерский, ул. Лесная, д. 7,
                    кв. 1/А
                  </li>
                </ul>
                <br />
                Оператор обязуется рассмотреть запрос Пользователя и направить
                ответ в течение 10 (десяти) рабочих дней с даты его получения;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">7.2</span>
              <p>
                В данном документе будут отражены любые изменения Политики
                обработки персональных данных Оператором. Политика действует
                бессрочно до замены ее новой версией;
              </p>
            </div>
            <div className="privacy-list-item">
              <span className="privacy-number">7.3</span>
              <p>
                Актуальная версия Политики в свободном доступе расположена в
                сети Интернет по адресу{" "}
                <a
                  href="https://mobile.itfox-web.com/privacy-policy/ru"
                  style={{ color: "#FFa910" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  mobile.itfox-web.com
                </a>
                .
              </p>
            </div>
          </>
        ) : (
          <p></p>
        )}
      </div>
    </section>
  );
};
